import "core-js/modules/es.array.concat.js";
export default (function (_ref) {
  var request = _ref.request;
  return {
    monitorAdd: function monitorAdd(data) {
      return request({
        url: '/monitor/oemDevice/add',
        method: 'post',
        data: data
      });
    },
    monitorModify: function monitorModify(data) {
      return request({
        url: "/monitor/oemDevice/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    monitorDel: function monitorDel(id) {
      return request({
        url: "/monitor/oemDevice/".concat(id, "/del"),
        method: 'delete'
      });
    },
    monitorQuery: function monitorQuery(data) {
      return request({
        url: '/monitor/oemDevice/query',
        method: 'get',
        params: data
      });
    },
    monitorQueryJoinPower: function monitorQueryJoinPower(data) {
      return request({
        url: '/monitor/oemDevice/queryJoinRecord',
        method: 'get',
        params: data
      });
    },
    monitorDetail: function monitorDetail(id) {
      return request({
        url: "/monitor/oemDevice/".concat(id, "/detail"),
        method: 'get'
      });
    },
    monitorReport: function monitorReport(labId, id) {
      return request({
        url: "/monitor/oemDevice/".concat(labId, "/").concat(id, "/report"),
        method: 'get'
      });
    },
    monitorReportModel: function monitorReportModel(labId, id, model, params) {
      return request({
        url: "/monitor/oemDevice/".concat(labId, "/").concat(id, "/report/").concat(model),
        method: 'get',
        params: params
      });
    }
  };
});